import React, { Component } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Heart, HeartOff } from 'lucide-react';

import { Button } from '../ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import {
  getFollowingPromise,
  addFollowingPromise,
  removeFollowingPromise,
} from '../../actions/promises';
import { RootState } from '../../types/redux';

export const FollowingBtnGuide: React.FC = () => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="destructive"
          size="sm"
        >
          <Heart className="h-4 w-4" />
          <span className="ml-2">追蹤</span>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>登入來使用追蹤功能</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

interface OwnProps {
  id: string;
  platform: string;
  type: string;
}

interface State {
  isFollowing: boolean | null;
  isFetching: boolean;
}

const mapStateToProps = (state: RootState) => ({
  isMobile: state.browser.lessThan.medium,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & OwnProps;

class FollowingBtn extends Component<Props, State> {
  state: State = {
    isFollowing: null,
    isFetching: false,
  }

  componentDidMount() {
    const {
      id,
      platform,
      type,
    } = this.props;

    this.setState({
      isFetching: true,
    });

    getFollowingPromise(platform, type, id)
      .then((res) => this.setState({
        isFollowing: Boolean(res.data),
        isFetching: false,
      }))
      .catch(() => {
        this.setState({
          isFetching: false,
        });
      });
  }

  handleOnClick = () => {
    const {
      id,
      platform,
      type,
    } = this.props;
    const {
      isFollowing,
    } = this.state;
    const promise = isFollowing ? removeFollowingPromise : addFollowingPromise;

    this.setState({
      isFetching: true,
    });

    promise(platform, type, id)
      .then(() => this.setState({
        isFollowing: !isFollowing,
        isFetching: false,
      }))
      .catch(() => {
        this.setState({
          isFetching: false,
        });
      });
  }

  render() {
    const {
      isFollowing,
      isFetching,
    } = this.state;

    const { isMobile } = this.props;

    return (
      <Button
        size="sm"
        disabled={isFollowing === null || isFetching}
        variant={isFollowing ? "secondary" : "destructive"}
        onClick={this.handleOnClick}
        className="relative"
      >
        {isFetching ? (
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
        ) : (
          isFollowing ? <HeartOff className="h-4 w-4" /> : <Heart className="h-4 w-4" />
        )}
        {!isMobile && (
          <span className="ml-2">
            {isFollowing ? '放棄追蹤' : '追蹤'}
          </span>
        )}
      </Button>
    );
  }
}

// @ts-ignore - TypeScript issue with React 18 and react-redux types
export default connector(FollowingBtn) as React.ComponentType<OwnProps>;